import React from "react";
import { Helmet } from 'react-helmet-async';
import '../Styles/ins_16.css';

function BlogPage() {

  const pageUrl = encodeURIComponent('https://outstandingworkplaces.co/shaping');
  const shareText = encodeURIComponent('Shaping the Future of Work HR Voices by Outstanding Workplaces!');

  const handleTwitterShare = () => {
    window.open(`https://twitter.com/intent/tweet?url=${pageUrl}&text=${shareText}`, '_blank', 'width=600,height=500');
  };

  const handleLinkedInShare = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleFacebookShare = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`, '_blank', 'width=600,height=500');
  };

  const handleWhatsAppShare = () => {
    window.open(`https://wa.me/?text=${shareText}%20${pageUrl}`, '_blank');
  };

  return (
    <>
      <Helmet>
        <title>Shaping Future — Outstanding Workplaces</title>
        <meta property="og:title" content="Shaping Future — Outstanding Workplaces" />
        <meta property="og:description" content="Shaping the Future of Work HR Voices by Outstanding Workplaces" />
        <meta property="og:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778049199/i_16_tj6wuc.jpg" />
        <meta property="og:url" content="https://outstandingworkplaces.co/shaping" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Shaping Future — Outstanding Workplaces" />
        <meta name="twitter:description" content="Shaping the Future of Work HR Voices by Outstanding Workplaces" />
        <meta name="twitter:image" content="https://res.cloudinary.com/daflhizdn/image/upload/v1778049199/i_16_tj6wuc.jpg" />
      </Helmet>

       <div className="sight_16_page_wrapper">
        <div className="sight_16_content_container">

          <div className="sight_16_section_one">

            <h1 className="sight_16_page_title">
              Shaping the Future of Work HR Voices by Outstanding Workplaces
            </h1>

            <div className="sight_16_row">

              <div className="sight_16_left">
                <div className="sight_16_image_wrapper">
                  <img src="/assets/i_16.jpg" alt="Team meeting discussion" className="sight_16_blog_image" />
                </div>




                {/* SHARE SECTION */}
                <div className="sight_16_share_section">
                  <span className="sight_16_share_text">Share :</span>
                  <div className="sight_16_social_icons">

                    <img
                      src="/assets/Twitter_1.png"
                      className="sight_16_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleTwitterShare}
                      alt="Share on Twitter"
                    />

                    <img
                      src="/assets/LinkedIn_1.png"
                      className="sight_16_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleLinkedInShare}
                      alt="Share on LinkedIn"
                    />

                    <img
                      src="/assets/Facebook_1.png"
                      className="sight_16_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleFacebookShare}
                      alt="Share on Facebook"
                    />

                    <img
                      src="/assets/WhatsApp_1.png"
                      className="sight_16_social_icon"
                      style={{ cursor: 'pointer' }}
                      onClick={handleWhatsAppShare}
                      alt="Share on WhatsApp"
                    />

                  </div>
                </div>

            <div className="sight_16_intro_wrapper">
                  <p className="sight_16_intro_paragraph p1">
                    As oorganizationsnavigate rapid change, one truth stands clear — workplace culture is no longer a byproduct of business strategy; it is the strategy. At the heart of this transformation lies thought leadership — the ability to inspire, influence, and guide organizations toward better ways of working.
                  </p>

                  <p className="sight_16_intro_paragraph p2">
                    At HR Voices by Outstanding Workplaces, this powerful intersection of thought leadership and workplace culture takes center stage.
                  </p>

                </div>

              </div>

              <div className="sight_16_right">
                <div className="sight_16_ad_card">
                  <img src="/assets/bc_1.png" className="sight_16_ad_bg" />
                  <div className="sight_16_ad_overlay"></div>
                  <img src="/assets/bg_1.png" className="sight_16_ad_badge" />

                  <div className="sight_16_ad_content">
                    <h2>
                      Earn the Outstanding <br />
                      <span>Workplaces Certification</span>
                    </h2>

                    <ul>
                      <li>Attract Top Talent</li>
                      <li>Boost Employee Engagement</li>
                      <li>Drive Culture-Led Growth</li>
                    </ul>

                    <button
                      className="sight_16_ad_btn"
                      onClick={() => window.location.href = '/nominate'}
                    >
                      Get Certificate
                    </button>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div className="sight_16_section">

            <div className="sight_16_topics">

              <div className="sight_16_topic_item">
                <h2 className="sight_16_topic_heading">
                  What is Thought Leadership in HR?
                </h2>

                <p className="sight_16_intro">
                  Thought leadership in today’s workplace goes beyond sharing ideas - it is about challenging conventional thinking and driving meaningful change.
                </p>

                <p className="sight_16_label">
                  HR leaders as thought leaders:
                </p>

                <ul className="sight_16_topic_list">
                  <li>Shape organizational values and culture</li>
                  <li>Influence leadership behavior and decision-making</li>
                  <li>Champion innovation and people-first strategies</li>
                  <li>Drive conversations that matter</li>
                </ul>

                <p className="sight_16_description">
                  They don’t just follow trends — they define what comes next.
                </p>
              </div>



              <div className="sight_16_topic_item">
                <h2 className="sight_16_topic_heading">
                  Culture: The Invisible Force That Drives Everything
                </h2>

                <p className="sight_16_intro">
                  Workplace culture is often described as “how things get done.” But in reality, it is much more — it is the shared beliefs, behaviors, and experiences that define an organization.
                </p>

                <p className="sight_16_label">
                  A strong culture:
                </p>

                <ul className="sight_16_topic_list">
                  <li>Builds trust and transparency</li>
                  <li>Encourages collaboration and innovation</li>
                  <li>Enhances employee engagement and wellbeing</li>
                  <li>Drives long-term performance and growth</li>
                </ul>

                <p className="sight_16_description">
                  Organizations with intentional cultures don’t leave it to chance — they design it with purpose.
                </p>
              </div>



              <div className="sight_16_topic_item">
                <h2 className="sight_16_topic_heading">
                  HR Voices: Where Ideas Become Impact
                </h2>

                <p className="sight_16_intro">
                  HR Voices creates a platform where forward-thinking HR leaders and industry experts come together to share insights, experiences, and bold perspectives on culture transformation.
                </p>

                <p className="sight_16_label">
                  Key conversations include:
                </p>

                <ul className="sight_16_topic_list">
                  <li>Building purpose-driven organizations</li>
                  <li>Creating inclusive and diverse workplaces</li>
                  <li>Leading through change and uncertainty</li>
                  <li>Embedding values into everyday work</li>
                  <li>Aligning culture with business strategy</li>
                </ul>

                <p className="sight_16_description">
                  These discussions are not just inspirational — they are action-oriented and impact-driven.
                </p>
              </div>



              <div className="sight_16_topic_item">
                <h2 className="sight_16_topic_heading">
                  From Culture Statements to Culture in Action
                </h2>

                <p className="sight_16_intro">
                  Many organizations articulate strong values, but the real challenge lies in bringing those values to life.
                </p>

                <p className="sight_16_label">
                  Culture becomes real when:
                </p>

                <ul className="sight_16_topic_list">
                  <li>Leaders model the behaviors they expect</li>
                  <li>Employees experience consistency across teams</li>
                  <li>Recognition reinforces desired behaviors</li>
                  <li>Systems and processes support cultural goals</li>
                </ul>

                <p className="sight_16_description">
                  Thought leadership helps bridge the gap between intent and execution.
                </p>
              </div>



              <div className="sight_16_topic_item">
                <h2 className="sight_16_topic_heading">
                  The Role of Leaders in Culture Building
                </h2>

                <p className="sight_16_intro">
                  Leaders are the most influential drivers of workplace culture. Their actions, decisions, and communication define the employee experience.
                </p>

                <p className="sight_16_label">
                  Effective leaders:
                </p>

                <ul className="sight_16_topic_list">
                  <li>Lead with authenticity and empathy</li>
                  <li>Encourage open dialogue and feedback</li>
                  <li>Foster psychological safety</li>
                  <li>Inspire purpose and accountability</li>
                </ul>

                <p className="sight_16_description">
                  In today’s workplace, leadership is not about authority — it’s about influence and impact.
                </p>
              </div>



              <div className="sight_16_topic_item">
                <h2 className="sight_16_topic_heading">
                  The Future of Workplace Culture
                </h2>

                <p className="sight_16_label">
                  As organizations evolve, workplace culture will be shaped by:
                </p>

                <ul className="sight_16_topic_list">
                  <li>Hybrid and flexible work models</li>
                  <li>Greater emphasis on employee wellbeing</li>
                  <li>Continuous learning and adaptability</li>
                  <li>Inclusion, equity, and belonging</li>
                  <li>Purpose-driven leadership</li>
                </ul>

                <p className="sight_16_description">
                  The organizations that succeed will be those that actively listen, adapt, and evolve their culture.
                </p>
              </div>

            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default BlogPage;
